/*global angular,env*/

angular.module('MrDWebApp.services', ['ngResource'])
  .constant('baseURL', env.apiURL? env.apiURL : 'api/')
  .constant('rootURL', env.rootHost? env.rootHost : '/')
  // .constant('hostname', 'api.pp.mrd.com/')
  .factory('settingsFactory', function ($resource, baseURL) {
    return $resource(
      baseURL + 'settings',{limit: 100},null);
  })
  .factory('landingItemsFactory', function ($resource, baseURL) {
    console.log('landing items factory start: ');
    return $resource(
      baseURL + 'landing-items',
      null, {
        lookup: {
          method: 'GET',
          cache: true,
        },
        update: {
          method: 'PUT'
        },
        get: {
          cache: true
        }
      }
    );
  })
  .factory('menuFactory', function ($resource, baseURL) {
    return $resource(
      baseURL + 'v2/menus/:menuID?flattened=true',
      null, {
        get: {
          method: 'GET',
          cache: false
        },
        query: {
          method: 'GET',
          cache: true, isArray: true
        }
      }
    );
  })
  .factory('orderFactory', function ($resource, baseURL) {

    return $resource(
      baseURL + 'v3/users/:userID/orders/:orderID',
      null, {
        update: {
          method: 'PUT'
        },
        history: {
          method: 'GET',
          params: {'sort:id': 'desc', 'limit': 25}
        }
      }
    );
  })
  .factory('loginFactory', function ($resource, baseURL) {
    return {
      login: function (encoded, success_callback, error_callback) {
        return $resource(baseURL + 'v3/users', {}, {
          query: {method: 'GET', headers: {Authorization: encoded}}
        }).query(null, null, function success(response) {
          success_callback(response);
        },
        function err(response) {
          error_callback(response);
        });
      },
      register: function (object, success_callback, error_callback) {
        return $resource(baseURL + 'v3/users', null, {
          query: { method: 'POST' }
        }).save(null, object, function success(response) {
          success_callback(response);
        },
        function err(response) {
          error_callback(response);
        });
      },
      forgot: function (email, success_callback, error_callback) {
        return $resource(baseURL + 'v3/users/passwordresetrequest', null, {
          query: {method: 'POST'}
        }).query(null, { 'email' : email }, function success(response) {
          success_callback(response);
        },
        function err(response) {
          error_callback(response);
        });
      },
      reset: function (password, confirm_password, token, success_callback, error_callback) {
        return $resource(baseURL + 'v3/users/passwordresetrequest/' + token, null, {
          query: {method: 'PUT'}
        }).query(null, {'new_password': password, 'new_password_confirmed': confirm_password}, function success(response) {
          success_callback(response);
        },
        function err(response) {
          error_callback(response);
        });
      },
      updateAccount: function (user_id,profile,success_callback,error_callback) {
        return $resource(baseURL + 'v3/users/' + user_id, null, {
          query: {method: 'PUT'}
        }).query(null, profile, function success(response) {
          success_callback(response);
        },
        function err(response) {
          error_callback(response);
        });
      }
    };
  })
  .factory('userFactory', function ($resource, baseURL) {

    return $resource(
      baseURL + 'v3/users/:userID',
      null, {
        'update': { method:'PUT' }
      }
    );
  })
  .factory('walletFactory', function ($resource, baseURL) {

    return $resource(
      baseURL + 'v3/users/:userID/wallet/refunds',
      null, {
        history: {
          method: 'GET',
          params: {'limit': 25}
        }
      }
    );
  })
  .factory('formFactory', function ($resource, baseURL) {

    return $resource(
      baseURL + 'forms', null, null
    );

	})
	.factory('voteAreaFactory', function ($resource, baseURL) {

    return $resource(
      baseURL + 'vote_for_area', null, null
    );

  })
  .factory('invoiceFactory', function ($resource, baseURL) {
    return {
      invoice: function (order_id) {
        return $resource(
          baseURL + 'orders/' + order_id + '/invoice-event',null,null
        ).save();
      },
      invoiceAlternative: function (order_id,email) {
        return $resource(
          baseURL + 'orders/' + order_id + '/invoice-event',null,null
        ).save( {
          'event_type':'email',
          'recipients': [email]
        });
      }
    };
  })
  .factory('geolocationSvc', function ($q, $window) {

    'use strict';

    function getCurrentPosition() {
        var deferred = $q.defer();

        if (!$window.navigator.geolocation) {
            deferred.reject('Geolocation not supported.');
        } else {
            $window.navigator.geolocation.getCurrentPosition(
                function (position) {
                    deferred.resolve(position);
                },
                function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    }

    return {
        getCurrentPosition: getCurrentPosition
    };
  })
  .factory('sendbird', function ($rootScope, $http, baseURL, storage) {
    var userId = storage.get('sb_id'), userToken = storage.get('sb_token');
    var user, channel, connecting = false, connectError;
    var sb = new window.SendBird({appId: env.sendbirdAppId});
    var isChannelFrozen = false, isUserMuted = false, isUserBanned = false;

    function connect(id, token) {
      return new Promise(function (resolve,reject) {
        sb.connect(id, token, function(u, error) {
          if (error) {
            reject(error);
          } else {
            resolve(u);
          }
        });
      });
    }

    function getChannel(url) {
      return new Promise(function(resolve,reject) {
        sb.GroupChannel.getChannel(url, function(ch, error) {
          if (error) {
            reject(error);
          } else {
            resolve(ch);
          }
        });
      });
    }

    var channelHandler = new sb.ChannelHandler();

    var context = {
      isSignedUp: function (){
        return !!userId;
      },
      signup: function(uid, userName, pushToken) {
        console.log('Signup with push token', pushToken);
        return $http.post(baseURL+'courier-chat/signup', {id:uid, name:userName, push_token:pushToken}, {bypassErrorHandler:true})
        .then(function(res){
          userId = res.data.id;
          userToken = res.data.token;
          storage.set('sb_id', userId);
          storage.set('sb_token', userToken);
        })
        .catch(function(res){
          if (res.data.error) {
            throw new Error(res.data.error.developer_message);
          }
          throw new Error('Driver chat signup failed.');
        });
      },
      connect: function(channelUrl) {
        if (!userToken) return Promise.reject('User need to be signed in before connecting.');
        if (connecting) return Promise.reject('Already busy connecting.');
        connecting = true;
        return connect(userId, userToken)
        .then(function(u) {
          user = u;
          return getChannel(channelUrl);
        })
        .then(function(ch) {
          channel = ch;
          connecting = false;
        })
        .catch(function(er) { //eg: 800102 - CONNECTION_CANCELED
          connecting = false;
          var msg = (er&&er.message)? er.message : (er? er : '');
          throw new Error('Could not load chat. '+msg);
        });
      },
      getIsChannelFrozen: function(){ return isChannelFrozen; },
      getUserId: function(){ return user.userId; },
      getIsUserMuted: function(){ return isUserMuted; },
      getIsUserBanned: function(){ return isUserBanned; },
      onMessageUpdated: null,
      onMessageReceived: null,
      onReadReceiptUpdated: null,
      onChangeChannelFreeze: null,
      onChangeMute: null,
      onChangeBan: null,
      loadMore: function(limit) {
        return new Promise(function(resolve,reject) {
          var q = channel.createPreviousMessageListQuery();
          q.limit = limit? limit : 10;
          q.reverse = true;
          q.load(function(msgs,er) {
            if (er) {
              console.warn('Could not load previous messages.');
              reject(er);
            } else {
              resolve(msgs);
            }
          });
        });
      },
      send: function(text) {
        return new Promise(function(resolve,reject){
          var params = new sb.UserMessageParams();
          params.message = text;
          channel.sendUserMessage(params, function(msg,er) {
            if (er) {
              if (er.code === 900041) {
                isUserMuted = true;
                if (!context.onChangeMute) return;
                $rootScope.$apply(function () {
                  context.onChangeMute(true);
                });
              } else if (er.code === 900100) {
                isUserBanned = true;
                if (!context.onChangeBan) return;
                $rootScope.$apply(function () {
                  context.onChangeBan(true);
                });
              } else if (er.code === 900050) {
                isChannelFrozen = true;
                if (!context.onChangeChannelFreeze) return;
                $rootScope.$apply(function () {
                  context.onChangeChannelFreeze(true);
                });
              }
              reject(er);
            } else {
              resolve(msg);
            }
          });
        });
      },
      markAsRead: function() {
        channel.markAsRead();
      },
      getReadReceipt: function(msg) {
        return channel.getReadReceipt(msg);
      },
      disconnect: function() {
        return new Promise(function(resolve,reject){
          sb.disconnect(function(){
            channel = null;
            resolve();
          });
        });
      }
    };
    

    channelHandler.onMessageUpdated = function(ch,message) {
      if (!channel || channel.url !== ch.url) return;
      if (!context.onMessageUpdated) return;
      $rootScope.$apply(function () {
        context.onMessageUpdated(message);
      });
    };
    channelHandler.onMessageReceived = function(ch,message) {
      if (!channel || channel.url !== ch.url) return;
      if (!context.onMessageReceived) return;
      $rootScope.$apply(function () {
        context.onMessageReceived(message);
      });
    };
    channelHandler.onReadReceiptUpdated = function(ch) {
      if (!channel || channel.url !== ch.url) return;
      if (!context.onReadReceiptUpdated)return;
      $rootScope.$apply(function () {
        context.onReadReceiptUpdated();
      });
    };
    channelHandler.onChannelFrozen = function(ch) {
      if (!channel || channel.url !== ch.url) return;
      isChannelFrozen = true;
      if (!context.onChangeChannelFreeze) return;
      $rootScope.$apply(function () {
        context.onChangeChannelFreeze(true);
      });
    };
    channelHandler.onChannelUnfrozen = function(ch) {
      if (!channel || channel.url !== ch.url) return;
      isChannelFrozen = false;
      if (!context.onChangeChannelFreeze) return;
      $rootScope.$apply(function () {
        context.onChangeChannelFreeze(false);
      });
    };
    channelHandler.onUserMuted = function(ch,u) {
      if (!channel || channel.url !== ch.url) return;
      if (!user || user.userId !== u.userId) return;
      isUserMuted = true;
      if (!context.onChangeMute) return;
      $rootScope.$apply(function () {
        context.onChangeMute(true);
      });
    };
    channelHandler.onUserUnmuted = function(ch,u) {
      if (!channel || channel.url !== ch.url) return;
      if (!user || user.userId !== u.userId) return;
      isUserMuted = false;
      if (!context.onChangeMute) return;
      $rootScope.$apply(function () {
        context.onChangeMute(false);
      });
    };
    channelHandler.onUserBanned = function(ch,u) {
      if (!channel || channel.url !== ch.url) return;
      if (!user || user.userId !== u.userId) return;
      isUserBanned = true;
      if (!context.onChangeBan) return;
      $rootScope.$apply(function () {
        context.onChangeBan(true);
      });
    };
    channelHandler.onUserUnbanned = function(ch,u) {
      if (!channel || channel.url !== ch.url) return;
      if (!user || user.userId !== u.userId) return;
      isUserBanned = false;
      if (!context.onChangeBan) return;
      $rootScope.$apply(function () {
        context.onChangeBan(false);
      });
    };
    sb.addChannelHandler('channelHandler', channelHandler);

    return context;
  })
  .factory('pushnotes', function ($rootScope, $location, $stateParams) {
    //var socket = io.connect();
    var token;

    var context = {
      requestPermission: function() {
        if (!window.firebase_msg) return Promise.reject();
        return window.firebase_msg.requestPermission()
        .then(function() {
          return window.firebase_msg.getToken();
        })
        .then(function(t){
          token = t;
          return t;
        });
      },
      unregister: function() {
        if (!window.firebase_msg) return Promise.reject();
        if (token) return window.firebase_msg.deleteToken(token);
        else return window.firebase_msg.getToken().then(function(t){
          return window.firebase_msg.deleteToken(t);
        }).catch(function(er){
          //never registered
          return true;
        });
      },
      onMessageReceived: null
    };

    // Handle incoming messages. Called when:
    // - a message is received while the app has focus
    // - the user clicks on an app notification created by a service worker
    //   `messaging.setBackgroundMessageHandler` handler.
    if (window.firebase_msg) window.firebase_msg.onMessage(function(payload) {
      
      //console.log('Payload', payload); //{"data": {"sendbird": "[JSON string]","message": "ALEXIS AMIITE NDUWE: hi"},"from": "554668785649","priority": "high","collapse_key": "do_not_collapse"}

      var chatData = null;
      try {
        chatData = JSON.parse(payload.data.sendbird);
      } catch (error) {
        console.error('Could not parse sendbird data.', error);
      }

      if (!chatData) return;
      console.log('chatData', JSON.stringify(chatData)); // {body:"MrD", title:"", icon:"", tag: "campaign_collapse_key_2584106511710417232"}
      
      if (context.onMessageReceived) {
        new Audio('/audio/your-turn.mp3').play().catch(function(er){});
        $rootScope.$apply(function () {
          context.onMessageReceived({
            isModerator: chatData.type === 'ADMM',
            invoice_number: chatData.channel.channel_url,
            userId: chatData.recipient.id.split('_')[1], 
            message: chatData.message,
            createdAt: new Date(chatData.created_at)
          });
        });
      }
    });

    if (navigator.serviceWorker) navigator.serviceWorker.addEventListener('message', function(e) {
      //console.log('Message from SW', e.data); // {type: "driver_chat", order: "DFD1063222", user: "mrdfood_753"}
      
      $location.search({map:$stateParams.map, chat:'1'});
      // $state.go('tracking', { //TODO: don't change state if this is already the active state
      //   orderID: e.data.order.substring(3),//trim 'DFD'
      //   userID: newDriverChatMessage.userId,
      //   map: '0',
      //   chat: '1'
      // });
    });

    return context;
  })
  .factory('ebucks', function ($rootScope, $location, $stateParams, $http, baseURL, storage) {
    var sessionToken;
    var context = {
      login: function(accNum,pin) {
        return $http.post(baseURL+'loyalty-programs/ebucks/accounts', {
          credentials: {
            auth: {
              member_id: ''+accNum,
              pin: ''+pin
            }
          }
        }, {bypassErrorHandler:true})
        .then(function(res){
          sessionToken = res.data.session_token;
          //console.log('ebucks login', res);
          // res.data == {
          //   accounts: [
          //     {
          //       balance: "95244000", 
          //       type: "EBUCKS_PERSONAL", 
          //       number: "80001295298", 
          //       name: "DWAYNE VERMEULEN"
          //     }
          //   ], 
          //   session_token: string
          // }
          return res.data.accounts;
        })
        .catch(function(res){
          var er = new Error('eBucks login failed.');
          if (res.data.error) Object.assign(er, res.data.error);
          throw er;
        });
      },
      getSessionToken: function(){
        return sessionToken;
      },
      getPin: function(accNum) {
        return $http.post(baseURL+'loyalty-programs/ebucks/pin', {
          credentials: {
            auth: {
              member_id: ''+accNum
            }
          }
        }, {bypassErrorHandler:true})
        .then(function(res){
          return res.data;
        })
        .catch(function(res){
          var er = new Error('eBucks forgot pin failed.');
          if (res.data.error) Object.assign(er, res.data.error);
          throw er;
        });
      },
      getOTP: function(orderId, iDriverTip, iRestaurantDonation) {
        return $http.post(baseURL+'loyalty-programs/ebucks/otp', {
          credentials: {
            session_token: sessionToken
          },
          order_id: orderId,
          driver_tip: (iDriverTip || 0) + (iRestaurantDonation || 0)
        }, {bypassErrorHandler:true})
        .then(function(res){
          return res.data;
        })
        .catch(function(res){
          var er = new Error('eBucks request OTP failed.');
          if (res.data.error) Object.assign(er, res.data.error);
          er.sessionExpired = res.status === 401 || res.status === 403;
          throw er;
        });
      },
      validateOTP: function(otp) {
        return $http.post(baseURL+'loyalty-programs/ebucks/validate-otp', {
          credentials: {
            session_token: sessionToken
          },
          otp: otp
        }, {bypassErrorHandler:true})
        .then(function(res){
          return res.data;
        })
        .catch(function(res){
          var er = new Error('eBucks OTP validation failed.');
          if (res.data.error) Object.assign(er, res.data.error);
          er.sessionExpired = res.status === 401 || res.status === 403;
          throw er;
        });
      }
    };

    return context;
  });
